import React from "react"
import QueryBuilder from "./components/QueryBuilder"
import { Provider } from "./state/filterExpressions"

const App: React.FC = () => {
  return (
    <Provider>
      <QueryBuilder />
    </Provider>
  )
}

export default App
